import { ReactNode, ReactPortal } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: ReactNode;
  id?: string;
}

export function Portal({ children, id = 'portal-root' }: Props): ReactPortal | null {
  const mount = document.getElementById(id) as HTMLElement;
  if (!mount) {
    return null;
  }

  return createPortal(children, mount);
}
